import { type AxiosCompatibleResponse } from '../http/types';

import { type BrandsBatchIdsResponse } from './types';

import {
  BRANDS_ENDPOINT,
  BRANDS_BATCH_BY_ID_ENDPOINT,
  BRANDS_BY_LETTER_ENDPOINT,
  BRANDS_BATCH_BY_SLUG_ENDPOINT,
} from '@/constants/endpoints';
import http, { typedHttp } from '@/modules/http';
import { replacePathParams } from '@/modules/http/replacePathParams';
import { depopMetaToHeaders } from '@/modules/search/api';
import { type DepopRequestMeta } from '@/modules/search/types';

export async function fetchOrderedBrandsByLetter(letter: string) {
  const { data } = await typedHttp.get(
    replacePathParams(BRANDS_BY_LETTER_ENDPOINT, { letter }),
    {
      cache: 'force-cache',
    }
  );

  return data;
}

export async function fetchBrands() {
  return typedHttp.get(BRANDS_ENDPOINT, {
    cache: 'force-cache',
  });
}

export async function fetchBrandsBatchIds({
  brandIds,
  meta,
}: {
  brandIds: string[] | number[];
  meta: DepopRequestMeta;
}): Promise<AxiosCompatibleResponse<BrandsBatchIdsResponse>> {
  return http.get(
    BRANDS_BATCH_BY_ID_ENDPOINT.replace(':brandIds', brandIds.join(',')),
    {
      cache: 'force-cache',
      headers: depopMetaToHeaders(meta),
    }
  );
}

export async function fetchBrandsBatchBySlugs({
  brandSlugs,
}: {
  brandSlugs: string[];
}) {
  return typedHttp.get(
    replacePathParams(BRANDS_BATCH_BY_SLUG_ENDPOINT, {
      slugs: brandSlugs.join(','),
    })
  );
}
